<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<div class="title">相关病例</div>
			<div class="back">
				<el-button @click="back" size="mini">返回</el-button>
			</div>
		</div>
		<div class="listLine">
			<el-table :data="tableData" height="100%" style="width: 100%">
				<el-table-column label="创建时间" width="175">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.createTime,'YYYY-MM-DD HH:mm')}}</span>
					</template>
				</el-table-column>
				<el-table-column label="病例号" width="250">
					<template slot-scope="scope">
						{{scope.row.caseNumber}}
					</template>
				</el-table-column>
				<el-table-column label="宠物">
					<template slot-scope="scope">
						{{scope.row.petName}}
					</template>
				</el-table-column>
				<el-table-column label="品种">
					<template slot-scope="scope">
						{{scope.row.typeName}}
					</template>
				</el-table-column>
				<el-table-column label="科室" width="90">
					<template slot-scope="scope">
						{{scope.row.departmentName}}
					</template>
				</el-table-column>
				<el-table-column label="医生" width="100">
					<template slot-scope="scope">
						{{scope.row.doctorName}}
					</template>
				</el-table-column>
				<el-table-column label="权益抵扣金额" width="135">
					<template slot-scope="scope">
						{{scope.row.rightsDeduction}}
					</template>
				</el-table-column>
				<el-table-column label="总金额" width="90">
					<template slot-scope="scope">
						{{scope.row.alreadyPayMoney}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120">
					<template slot-scope="scope">
						<el-button type="text" @click="toBingliSee(scope.row)" style="margin-right: 5px;">查看</el-button>
						<!-- <span v-if="scope.row.isPay===false">
							<el-button type="text" @click="pay(scope.row)">结算</el-button>
							<el-button type="text" @click="cancel(scope.row)">取消</el-button>
						</span> -->
					</template>
				</el-table-column>
				<span slot="empty">
					<img src="../../../../assets/img/konging.png" style="width:271px;margin-top:100px;"/>
					<div style="font-size: 16px;color:#999;margin:20px;">这个人什么痕迹都没留下</div>
				</span>
			</el-table>
		</div>
		<div class="pageLine">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<!-- <ximeiSee v-if="drawerSee_state" :curItem="curItem" @submit="submit_drawerSee"></ximeiSee> -->
		<!-- 结算 -->
		<!-- <div v-if="dialogSettlement_state">
			<dialogSettlement :orderId="curItem.orderNum" @submit="submit_dialogSettlement"></dialogSettlement>
		</div> -->
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	// import ximeiSee from "../drawer/ximeiSee.vue"
	// import dialogSettlement from "../../../../components/dialog_settlement.vue"
	export default {
		components:{page},
		data(){
			return{
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				// see
				drawerSee_state:false,
				curItem:{},
			}
		},
		computed:{
			curCard(){
				return this.$store.state.huiyuanquanyi.curCard;
			},
		},
		watch:{
		},
		mounted(){
			console.log(this.curCard)
			this.getTableData();
		},
		methods: {
			back(){
				this.$store.commit('huiyuanquanyi/set_type','list')
			},
			// 查看
			toBingliSee(row){
				this.$router.push({path:"/yiliao/bingliEdit?type=see&eid="+row.caseNumber})
			},
			// submit_drawerSee(){
			// 	this.drawerSee_state = false;
			// 	this.getTableData();
			// },
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			// 获取寄养列表
			getTableData() {
				let params = {
					"departmentId": '',
					"petId": "", 
					isPay:-1, // -1不限；0未支付；1已支付
					isInspect:-1,  // -1不限；0未检测；1已检测
					isVisit:-1,  // -1不限；0未回访；1已回访
					isEnter:-1,  
					showLater:false,
					"desc": true, // true  倒序  false 正序
					"begin_time": "",
					"end_time": "",
					rightsNum:this.curCard.rights_num,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": ''
				}
				let loading=this.$loading();
				this.$http.post('/api/Case/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:48px 0 0;box-sizing: border-box;position: relative;
	.titleLine{width:100%;background-color: #fff;padding:12px 10px 8px;box-sizing: border-box;position: absolute;top:0;display: flex;justify-content: space-between;
		.title{
			font-size: 18px;color:#101010;font-weight: bold;padding-left:12px;border-left:5px solid $mainColor;line-height: 28px;
		}
		.back{
			
		}
	}
	.listLine{
		height: 100%;padding:0 0px 60px 0px;box-sizing: border-box;
	}
	.pageLine{
		position: absolute;bottom:0;z-index: 1;width:100%;padding:10px;background-color: #fff;box-sizing: border-box;
	}
}
</style>
